class VgTable {
	constructor(
		gymId,
		prefetchedGymData = {subscriptionsData : null, availableGymsByRegion: null, availableGymsByPrice: null, availableGymsByCluster: null, gymBillingPeriod: null},
		displayOptions = { withCTA : false, tabletView : false, newJoining : false }
	){
		this.center = gymId;
		this.cta = displayOptions?.withCTA ? displayOptions.withCTA : false;
		this.tableElement = document.querySelector('.vg-table');
		this.country = VgHelpers.getCountry();
		this.lang = VgHelpers.getLanguage();
		this.tabletView = displayOptions?.tabletView ? displayOptions.tabletView : false;
		// NEW JOINING SWITCH: gym with the new join enabled ("New Joining" admin page), temporary, see vivagym-web/post-types/gym/vg_gym_new_joining.php.
		this.newJoining = displayOptions?.newJoining ? displayOptions.newJoining : false;
		this.prefetchedGymData = prefetchedGymData ? prefetchedGymData : {subscriptionsData : null, availableGymsByRegion: null, availableGymsByPrice: null, availableGymsByCluster: null, gymBillingPeriod: null};
		this.gymBillingPeriod = null;
		this.vgApiClient = new VgApiClient(this.country, this.lang);
		this.tableReady = this.init();
	}

	async init() {
		if (!this.tableElement) {
			console.error("Table element not found");
			return;
		}
		let subscriptionsData;

		if (!this.prefetchedGymData?.subscriptionsData) {
			subscriptionsData = await this.vgApiClient.getSubscriptions(this.center, this.country);
		} else {
			subscriptionsData = this.prefetchedGymData.subscriptionsData;
		}

		if (!subscriptionsData || subscriptionsData?.error) {
			console.error("Error getting subscriptions data");
			const container = document.querySelector(".vg-compare-table__container");
			container.innerHTML = '';

			const navigationList = document.querySelector(".vg-navigation-tabs__list");
			const firstItem = navigationList?.firstElementChild;
			if (firstItem) firstItem.style.display = "none";

			return;
		}

		this.addSubscriptionFilterEvents(subscriptionsData);
		await this.renderComparisionTable(this.center, this.tableElement, subscriptionsData);
		if (this.cta) {
			this.renderCTA(subscriptionsData);
			if ( VgSubscriptions.subscriptionsHasStudent(subscriptionsData)) {
				this.renderStudentSubscription(subscriptionsData);
			}
			document.addEventListener("vgTableSubscriptionFilterChanged", (event) => {
				this.renderCTAColumns(event.detail.filteredSubscriptions);
			});
		}
		this.addEventTooltipOnTable();
	}

	async renderComparisionTable(gymId, tableElement, subscriptionsData) {
		if ( null == gymId ) {
			return;
		}

		let currentCountry = this.country;
		let currentLang    = this.lang;
		if ( undefined === currentCountry || ( undefined === currentLang ) ) {
			currentCountry = VgHelpers.getCountry();
			currentLang    = VgHelpers.getLanguage();
		}

		let availableGymsBy;

		if (! this.prefetchedGymData?.availableGymsByRegion || ! this.prefetchedGymData?.availableGymsByPrice || ! this.prefetchedGymData?.availableGymsByCluster) {
			availableGymsBy = await this.vgApiClient.getSubscriptionsGymsBy(gymId);
		}

		const [availableGymsByRegion, availableGymsByPrice, availableGymsByCluster, gymParkingOptions, gymBillingPeriod, gymBAFOptions] = await Promise.all([
			this.prefetchedGymData?.availableGymsByRegion
				?? availableGymsBy?.gyms_by_region
				?? this.vgApiClient.getSubscriptionsGymsByRegion(gymId, currentCountry, currentLang),
			this.prefetchedGymData?.availableGymsByPrice
				?? availableGymsBy?.gyms_by_price
				?? this.vgApiClient.getSubscriptionsGymsByPrice(gymId, currentCountry, currentLang),
			this.prefetchedGymData?.availableGymsByCluster
				?? availableGymsBy?.gyms_by_cluster
				?? this.vgApiClient.getSubscriptionsGymsByCluster(gymId, currentCountry, currentLang),
			this.vgApiClient.getGymParkingOptions(gymId, currentCountry),
			this.prefetchedGymData?.gymBillingPeriod
				?? this.vgApiClient.getGymPricePeriod(gymId),
			this.vgApiClient.getGymBAFOptions(gymId)
		]);

		this.gymBillingPeriod = gymBillingPeriod;
		this.subscriptionsData = subscriptionsData;
		this.fetchedGymData = { availableGymsByRegion, availableGymsByCluster, availableGymsByPrice, gymParkingOptions, gymBAFOptions };

		const filteredSubscriptions = VgSubscriptions.getMainSubscriptions(subscriptionsData);

		this.renderTableColumns(tableElement, filteredSubscriptions);

		this.renderTableRows(tableElement, filteredSubscriptions, {
			subscriptionsData,
			availableGymsByRegion,
			availableGymsByCluster,
			availableGymsByPrice,
			gymParkingOptions,
			gymBAFOptions,
		});

		this.showFiltersByMostPopular(subscriptionsData);
		this.updateFootnotes();
		this.removeLoading(tableElement);
	}

	/**
	 * If MostPopular is a Quote with bindings, activate filters to most popular be seen 
	 * first on screen (and it month)
	 * @param {*} filteredSubscriptions 
	 */
	showFiltersByMostPopular(filteredSubscriptions) {
		let selectionChanged = false;

		filteredSubscriptions.subscriptions.forEach((subscription) => {
			if (subscription.product.mostPopular) {
				if (subscription.binding > 0 ) {
					// Select the lock-in filter
					const lockElement = document.getElementById('vg-switch-selector--lock-in');
					if (null !== lockElement) {
						lockElement.checked = true;
						selectionChanged = true;
					}
					// Select the month filter
					const bindingInput = document.getElementById('vg-switch-selector--subscription-' + subscription.binding);
					if (null !== bindingInput) {
						bindingInput.checked = true;
						selectionChanged = true;
					}
				}
			}
		});

		if (selectionChanged) {
			this.toggleLockSelectorVisibility();
			this.applySubscriptionFilter();
		}
	}

	updateFootnotes() {
		const contractDurationNote = document.querySelector('.vg-table__footnote-contract-duration');

		if (contractDurationNote) {
			const lockIn = document.querySelector('[name="lock-in"]:checked')?.value;
			const months = document.querySelector('[name="subscription-selection"]:checked')?.value;
			const showContractDurationNote = lockIn === 'lock-in';

			contractDurationNote.style.display = showContractDurationNote ? '' : 'none';

			if (showContractDurationNote) {
				contractDurationNote.innerHTML = contractDurationNote.dataset.template.replace('[MONTH]', months);
			}
		}
	}

	addSubscriptionFilterEvents(subscriptionsData) {
		const bindingSubscriptions = VgSubscriptions.getBindingSubscriptions(subscriptionsData);

		if (bindingSubscriptions.length === 0) {
			document.querySelector('.vg-table__subscription-filter')?.remove();
			return;
		}

		this.updateLockInSavings(subscriptionsData, this.getSelectedBindingMonths());

		document.querySelectorAll('[name="subscription-selection"]').forEach((radio) => {
			const months = parseInt(radio.value, 10);
			const hasSubscriptionForMonths = bindingSubscriptions.some(sub => VgSubscriptions.getBindingMonths(sub) === months);

			if (!hasSubscriptionForMonths) {
				document.querySelector(`label[for="${radio.id}"]`)?.remove();
				radio.remove();
			}
		});

		const remainingSubscriptionRadios = document.querySelectorAll('[name="subscription-selection"]');
		const hasCheckedSubscriptionRadio = [...remainingSubscriptionRadios].some(radio => radio.checked);

		if (!hasCheckedSubscriptionRadio && remainingSubscriptionRadios.length > 0) {
			remainingSubscriptionRadios[0].checked = true;
		}

		this.toggleLockSelectorVisibility();

		const filterRadios = document.querySelectorAll('[name="lock-in"], [name="subscription-selection"]');

		filterRadios.forEach((radio) => {
			radio.addEventListener("change", () => {
				this.toggleLockSelectorVisibility();
				this.applySubscriptionFilter();
			});
		});
	}

	getSelectedBindingMonths() {
		return parseInt(document.querySelector('[name="subscription-selection"]:checked')?.value, 10);
	}

	updateLockInSavings(subscriptionsData, months) {
		const savingsEl = document.querySelector('.vg-switch-selector__savings');
		if (!savingsEl) return;

		const bindingSubscriptions = VgSubscriptions.getBindingSubscriptions(subscriptionsData)
			.filter(sub => VgSubscriptions.getBindingMonths(sub) === months);

		const mainSubscription = VgSubscriptions.getMainSubscriptions(subscriptionsData)[0];
		const bindingSubscription = bindingSubscriptions[0];

		if (!mainSubscription || !bindingSubscription) return;

		const savings = parseFloat(mainSubscription.periodPrice) - parseFloat(bindingSubscription.periodPrice);
		const sign = savings >= 0 ? '-' : '+';

		savingsEl.textContent = ` (${sign}${VgHelpers.priceFormat(Math.abs(savings))}€/${VgHelpers.getBillingPeriodLabel(this.gymBillingPeriod)})`;
	}

	toggleLockSelectorVisibility() {
		const lockSelector = document.querySelector('.vg-table__subscription-lock-selector');
		if (!lockSelector) return;

		const lockIn = document.querySelector('[name="lock-in"]:checked')?.value;
		// Dont show selection if only one option is available, otherwise show it only when lock-in is selected
		if ( lockSelector.querySelectorAll('label').length === 1 ) {
			lockSelector.style.display = 'none';	
		} else {
			lockSelector.style.display = lockIn === 'lock-in' ? '' : 'none';
		}
	}

	applySubscriptionFilter() {
		if (!this.subscriptionsData) return;

		const lockIn = document.querySelector('[name="lock-in"]:checked')?.value;
		const months = document.querySelector('[name="subscription-selection"]:checked')?.value;

		const filteredSubscriptions = VgSubscriptions.filterByLockAndDuration(this.subscriptionsData, lockIn, months);

		this.updateLockInSavings(this.subscriptionsData, this.getSelectedBindingMonths());

		this.renderTableColumns(this.tableElement, filteredSubscriptions);
		this.renderTableRows(this.tableElement, filteredSubscriptions, {
			subscriptionsData: this.subscriptionsData,
			...this.fetchedGymData,
		});

		this.updateFootnotes();

		document.dispatchEvent(new CustomEvent("vgTableSubscriptionFilterChanged", {
			detail: { lockIn, months, filteredSubscriptions }
		}));
	}

	renderTableColumns(tableElement, filteredSubscriptions) {
		const maxCols = tableElement.querySelectorAll('thead [data-col-index]').length;

		for (let i = 0; i < maxCols; i++) {
			const isVisible = i < filteredSubscriptions.length;
			tableElement.querySelectorAll(`[data-col-index="${i}"]`).forEach(el => el.style.display = isVisible ? '' : 'none');
		}

		tableElement.className = tableElement.className.replace(/\bvg-table--col-\d+\b/g, '').trim();
		tableElement.classList.add("vg-table--col-" + filteredSubscriptions.length);

		filteredSubscriptions.forEach((subscription, colIndex) => {
			const subscriptionName = VgSubscriptions.parseSubscriptionLabel(subscription.product.webname);

			const isMostPopular = subscription.product.mostPopular;
			const th = tableElement.querySelector(`thead [data-col-index="${colIndex}"]`);
			if (!th) return;
			const div = th.querySelector('div');
			th.classList.toggle("quote-featured", isMostPopular);
			div.textContent = subscriptionName.toUpperCase();
		});
	}

	renderTableRows(tableElement, filteredSubscriptions, fetchedData) {
		const { subscriptionsData, availableGymsByRegion, availableGymsByCluster, availableGymsByPrice, gymParkingOptions, gymBAFOptions } = fetchedData;

		const haveOneFlexOrPrime = VgSubscriptions.haveOneFlexOrPrimeSubscription(subscriptionsData);
		const haveParking = VgSubscriptions.haveParking(subscriptionsData);
		const haveFreeWater = VgSubscriptions.haveFreeWater(subscriptionsData);
		const freeWaterName = VgSubscriptions.getWaterAddonName(subscriptionsData);

		this.toggleRowVisibility('parking', haveParking);
		this.toggleRowVisibility('free-water', haveFreeWater);

		tableReference.forEach((row, rowIndex) => {
			const rowKey = row.key ?? '';
			const tr = rowKey
				? tableElement.querySelector(`tbody tr[data-row-key="${rowKey}"]`)
				: tableElement.querySelector(`tbody tr[data-row-index="${rowIndex}"]`);

			if (!tr) return;

			const labelCell = tr.querySelector('.vg-table__cell-label');

			if (row.one_column) {
				const cells = [...tr.querySelectorAll('[data-col-index]')];
				const [firstCell, ...restCells] = cells;

				if (firstCell) {
					firstCell.colSpan = filteredSubscriptions.length;
					firstCell.style.gridColumn = `span ${filteredSubscriptions.length}`;
					firstCell.style.width = '100%';
					firstCell.style.display = '';
				}
				restCells.forEach(cell => cell.style.display = 'none');
			}

			if (rowKey === 'gym-count' && haveOneFlexOrPrime && row.label_2) {
				labelCell.innerHTML = row.label_2;
			}

			if (rowKey === 'free-water') {
				labelCell.innerHTML = freeWaterName
					? labelCell.innerHTML.replace("[WATER]", freeWaterName)
					: labelCell.innerHTML.replace("[WATER] ", "");
			}

			if (rowKey === 'baf' && gymBAFOptions?.row_label) {
				labelCell.innerHTML = gymBAFOptions.row_label;
			}

			if(rowKey === 'parking' && gymParkingOptions?.row_label) {
				labelCell.innerHTML = gymParkingOptions.row_label;
			}

			labelCell.innerHTML = labelCell.innerHTML.replace(
				"[BILLING_PERIOD]",
				`€/${VgHelpers.getBillingPeriodLabel(this.gymBillingPeriod)}`
			);

			filteredSubscriptions.forEach((subscription, colIndex) => {
				const td = tr.querySelector(`[data-col-index="${colIndex}"]`);
				if (!td) return;

				const isMostPopular = subscription.product.mostPopular;
				td.classList.toggle("quote-featured", isMostPopular);

				// TODO: when webParking is available, use it instead name
				const subscriptionName = VgSubscriptions.parseSubscriptionLabel(subscription.product.webname);

				if (row[subscriptionName] === true) {
					td.innerHTML = `<i class="icon icon--check"></i>`;
					return;
				}

				td.innerHTML = row[subscriptionName] ?? "";

				if (rowKey === 'gym-count') {
					td.innerHTML = subscription.availableGyms;

					if (VgSubscriptions.isOneSubscription(subscription)) {
						td.innerHTML = '1';
					}
					if (VgSubscriptions.isFlexSubscription(subscription)) {
						td.innerHTML = this.getGymAccessInfo(availableGymsByCluster, row);
					}
					if (VgSubscriptions.isPrimeSubscription(subscription)) {
						td.innerHTML = this.getGymAccessInfo(availableGymsByPrice, row);
					}
				}

				if (rowKey === 'parking' && subscription.parking) {
					td.innerHTML = `<i class="icon icon--check"></i>`;
				}

				if (rowKey === 'free-water' && subscription.freeWater) {
					td.innerHTML = `<i class="icon icon--check"></i>`;
				}

				if (rowKey === 'baf') {
					td.innerHTML = !subscription.BAF ? "" : gymBAFOptions['rank_' + subscription['WEB-SubscriptionLevel']] ?? "";
				}
			});

			if (rowKey === 'gym-count' && row['tooltip'] && !haveOneFlexOrPrime) {
				if (labelCell.querySelector('vg-tooltip')) return;
				let toolTipText = '';

				if (availableGymsByRegion?.error === null && !haveOneFlexOrPrime) {
					if (availableGymsByRegion.accessToAllGyms) {
						toolTipText = row['tooltip_1'];
					} else {
						const gymList = this.formatGymsByZone(availableGymsByRegion.regions);
						toolTipText = gymList ? row['tooltip_2'] + gymList : '';
					}
				}

				labelCell.innerHTML +=
				`
				<vg-tooltip>
					<i class="icon icon--help-question vg-tooltip__trigger"></i>
					<div class="vg-tooltip__panel">${toolTipText}</div>
				</vg-tooltip>
				`;
			}

			if (rowKey === 'parking' && row['tooltip'] && haveParking && gymParkingOptions.time) {
				if (labelCell.querySelector('vg-tooltip')) return;
				labelCell.innerHTML +=
				`
				<vg-tooltip>
					<i class="icon icon--help-question vg-tooltip__trigger"></i>
					<div class="vg-tooltip__panel vg-tooltip__panel--narrow">${row['tooltip'].replace("[HOURS]", gymParkingOptions.time)}</div>
				</vg-tooltip>
				`;
			}
		});

		VgTable.updateCreationPriceRow(filteredSubscriptions);
	}

	static updateCreationPriceRow(filteredSubscriptions) {
		const cell = document.querySelector('.vg-table tbody tr[data-row-key="creation"] [data-col-index="0"]');
		if (!cell) return;

		const subscription = filteredSubscriptions.find(sub => sub.product.mostPopular) ?? filteredSubscriptions[0];

		if (!subscription) {
			cell.innerHTML = '';
			return;
		}

		const isCreationPromoted  = subscription.creationPrice != subscription.creationNormalPrice;
		const isCreationPriceZero = subscription.creationPrice == "0.00";

		let html = `<span class="${isCreationPromoted ? 'vg-select-quote__underline-text' : ''}">${subscription.creationNormalPrice}€</span>`;

		if (isCreationPromoted && !isCreationPriceZero) {
			html += `<span class="vg-compare-table__creation-price-with-discount">${subscription.creationPrice}€</span>`;
		}

		cell.innerHTML = html;
	}

	removeLoading(element){
		element.closest('.is-loading')?.classList.remove('is-loading');
		document.querySelector('.vg-compare-table__content')?.classList.remove('is-loading');
		document.querySelector('.vg-select-quote__table')?.classList.remove('is-loading');
	}

	getGymAccessInfo(availableGyms, row){
		let rowIcon = `<i class="icon icon--check"></i>`;
		let tooltip = '';
		if (availableGyms && !availableGyms.accessToAllGyms) {
			const gymList  = this.formatGymsByZone(availableGyms.regions);
			const gymCount = this.countGymsByZone(availableGyms.regions);

			let toolTipText = gymList ? row['tooltip_2'] + gymList : '';
			tooltip =
				`
				<span>${gymCount}</span>
				<vg-tooltip>
					<i class="icon icon--help-question vg-tooltip__trigger"></i>
					<div class="vg-tooltip__panel">${toolTipText}</div>
				</vg-tooltip>
				`;
		}
		return availableGyms.accessToAllGyms === true ? rowIcon : tooltip;
	}

	toggleRowVisibility(rowName, isVisible) {
		const row = this.tableElement.querySelector(`tr[data-row-key="${rowName}"]`);
		if (row) row.style.display = isVisible ? '' : 'none';
	}

	formatGymsByZone(gymList) {

		if (!gymList) return '';
		if (Object.keys(gymList).length === 0) return '';

		let gymListFormatted = "<ul>";

		Object.entries(gymList).forEach(([region, gyms]) => {
			if (!gyms) return;
			if (typeof gyms === 'string') return gyms;

			let regionElement = '<li>';
			regionElement += `<strong>${region}:</strong> `;
			gyms.forEach(gym => {
				regionElement += `${gym}, `;
			});
			regionElement = regionElement.slice(0, -2);
			regionElement += '</li>';

			gymListFormatted += regionElement;

		});

		gymListFormatted += "</ul>";

		return gymListFormatted;
	}

	countGymsByZone(gymList) {
		if (!gymList) return '';
		if (Object.keys(gymList).length === 0) return '';

		const total = Object.values(gymList).reduce((count, gyms) => {
			if (!gyms || typeof gyms === 'string') return count;
			return count + gyms.length;
		}, 0);

		return total > 0 ? String(total) : '';
	}

	renderStudentSubscription(subscriptionsData) {
		if (this.tabletView) {
			return;
		}

		const studentContainer = document.querySelector('.vg-table__student-subscription');

		if (!studentContainer) return;

		const studentSubscriptions = VgSubscriptions.getStudentSubscriptions(subscriptionsData);
		const studentSubscription = studentSubscriptions[0];
		if (! studentSubscription) {
			return;
		}

		const template = document.querySelector("#student-template");
		if (!template) {
			return;
		}

		const clone = template.content.cloneNode(true);

		const subscriptionUrl = `/${this.country}-${this.lang}/joining-2/?gym=${this.center}&sub=${studentSubscription.product.globalId}${this.tabletView ? '&tablet=true' : ''}`;

		const studentContainerProduct = clone.querySelector(".vg-compare-table_student__quote");
		studentContainerProduct.setAttribute("data-global-id", studentSubscription.product.globalId);
		studentContainerProduct.addEventListener("click", () => {
			window.location = subscriptionUrl;
		});

		const subscriptionPrice = `${VgHelpers.getBillingPeriodPrice(studentSubscription.periodPrice, this.gymBillingPeriod)}€` + `/${VgHelpers.getBillingPeriodLabel(this.gymBillingPeriod)}`;
		const priceProduct = clone.querySelector(".vg-compare-table_student_description_price");
		priceProduct.innerHTML = subscriptionPrice;

		studentContainer.appendChild(clone);
	}

	renderCTA(subscriptionsData) {

		const featuredSubscription = VgSubscriptions.getFeaturedSubscription(subscriptionsData);
		const hasDaypass = VgSubscriptions.subscriptionsHasDaypass(subscriptionsData);
		const hasStudent = VgSubscriptions.subscriptionsHasStudent(subscriptionsData);

		if (featuredSubscription) {
			this.updatePromotionBanner(featuredSubscription);
		}

		if (!hasDaypass) {
			document.querySelector(".vg-compare-table__quotes-special").remove();
		}

		if (hasDaypass) {
			VgSubscriptions.getDayPassSubscriptions(subscriptionsData).forEach((subscription) => {
				this.renderDayPassCTA(subscription);
			});
		}

		if (hasStudent) {
			VgSubscriptions.getStudentSubscriptions(subscriptionsData).forEach((subscription) => {
				const subscriptionUrl = `/${this.country}-${this.lang}/joining-2/?gym=${this.center}&sub=${subscription.product.globalId}${this.tabletView ? '&tablet=true' : ''}`;
				if (this.tabletView) {
					let subscriptionOnePrice = null;
					const oneSubscriptions = VgSubscriptions.getOneSubscriptions(subscriptionsData);
					if (oneSubscriptions) {
						const oneSubscription = oneSubscriptions[0];
						if (oneSubscription) {
							subscriptionOnePrice = oneSubscription.periodPrice;
						}
					}

					const studentHeaderContainer = document.querySelector(".vg-compare-table__quotes-promotion");
					studentHeaderContainer.classList.add('tablet_promotion_container');
					const imageContainer = document.querySelector(".vg-compare-table__default_image");
					imageContainer.classList.add('disabled');

					this.renderSubscriptionStudentTablet(subscription, subscriptionUrl, subscriptionOnePrice);
				} else {
					//this.renderSubscriptionStudent(subscription, subscriptionUrl);
				}
			});
		}

		this.renderCTAColumns(VgSubscriptions.getMainSubscriptions(subscriptionsData));
	}

	renderCTAColumns(filteredSubscriptions) {
		const columns = [...this.tableElement.querySelectorAll("thead [data-col-index]")];

		columns.forEach((column) => {
			column.querySelector(".vg-select-quote__cta")?.remove();

			if (column.style.display === "none") return;

			const subscription = filteredSubscriptions[column.dataset.colIndex];
			if (!subscription) return;

			this.renderSubscriptionCTA(subscription, column);
		});
	}

	//TODO: eliminar todo esto
	/*renderSubscriptionStudent(subscription, subscriptionUrl) {
		const studentContainer = document.querySelector("#student-container");

		const template = document.querySelector("#student-template");
		const clone = template.content.cloneNode(true);

		const studentContainerProduct = clone.querySelector(".vg-compare-table_student__quote");
		studentContainerProduct.setAttribute("data-global-id", subscription.product.globalId);
		studentContainerProduct.addEventListener("click", () => {
			window.location = subscriptionUrl;
		});

		const subscriptionPrice = `${VgHelpers.getBillingPeriodPrice(subscription.periodPrice, this.gymBillingPeriod)}€` + `/${VgHelpers.getBillingPeriodLabel(this.gymBillingPeriod)}`;
		const priceProduct = clone.querySelector(".vg-compare-table_student_description_price");
		priceProduct.innerHTML = subscriptionPrice;

		studentContainer.appendChild(clone);
	}*/

	renderSubscriptionStudentTablet(subscription, subscriptionUrl, subscriptionOnePrice) {
		const studentContainer = document.querySelector(".vg-compare-table__quotes");

		const template = document.querySelector("#student-template-tablet");
		const clone = template.content.cloneNode(true);

		const studentContainerProduct = clone.querySelector(".vg-tablet_student__quotes");
		studentContainerProduct.setAttribute("data-global-id", subscription.product.globalId);

		const card = clone.querySelector(".vg-tablet_student_container");
		card.addEventListener("click", () => {
			window.location = subscriptionUrl;
		});
		card.setAttribute("data-testid", "subscription-" + subscription.product.globalId);

		const footerText = clone.querySelector(".vg-tablet_student_footer_text");
		footerText.innerHTML = footerText.innerHTML+subscription.product.name;

		const subscriptionPrice = `${VgHelpers.getBillingPeriodPrice(subscription.periodPrice, this.gymBillingPeriod)}€` + `<span class="vg-tablet_student_prices_time">/${VgHelpers.getBillingPeriodLabel(this.gymBillingPeriod)}</span>`;
		const priceProduct = clone.querySelector(".vg-tablet_student_prices_real");
		priceProduct.innerHTML = subscriptionPrice;

		if (subscriptionOnePrice) {
			const subscriptionOriginalPrice = `${VgHelpers.getBillingPeriodPrice(subscriptionOnePrice, this.gymBillingPeriod)}€` + `<span class="vg-tablet_student_prices_time_disabled">/${VgHelpers.getBillingPeriodLabel(this.gymBillingPeriod)}</span>`;
			const priceProductOriginal = clone.querySelector(".vg-tablet_student_prices_disabled");
			priceProductOriginal.innerHTML = subscriptionOriginalPrice;
		}

		studentContainer.appendChild(clone);
	}

	renderSubscriptionCTA(subscription, column) {
		const ctaTemplate = document.querySelector("#vg-table-cta-link-template");
		const clone = ctaTemplate.content.cloneNode(true);

		const link = clone.querySelector("a");
		const itemPrice = clone.querySelector(".item-price");
		const itemPriceLabel = clone.querySelector(".item-price-label");
		const itemPricePromo = clone.querySelector(".item-price-promo");

		// NEW JOINING SWITCH: monthly plans of gyms with the new join enabled go to the new join.
		const subscriptionUrl = this.newJoining
			? `/${this.country}-${this.lang}/join/?gymId=${this.center}&sub=${subscription.product.globalId}`
			: `/${this.country}-${this.lang}/joining-2/?gym=${this.center}&sub=${subscription.product.globalId}${this.tabletView ? '&tablet=true' : ''}`;
		link.href = subscriptionUrl;
		link.dataset.globalId = subscription.product.globalId;
		link.dataset.testid = "subscription-" + subscription.product.globalId;
		if (subscription.product.mostPopular) {
			link.classList.remove('ob-button--secondary', 'ob-button--outline');
		}

		const isSubscriptionPromoted = subscription?.proRataPriceSource ? true : false;
		const displayPrice = isSubscriptionPromoted ? subscription.proRataPrice : subscription.periodPrice;

		if (isSubscriptionPromoted) {
			itemPricePromo.textContent = `${VgHelpers.getBillingPeriodPrice(subscription.periodPrice, this.gymBillingPeriod)}€`;
			itemPricePromo.classList.add('vg-select-quote__underline-text');
		} else {
			itemPricePromo.textContent = '';
			itemPricePromo.classList.remove('vg-select-quote__underline-text');
		}

		itemPrice.textContent = `${VgHelpers.getBillingPeriodPrice(displayPrice, this.gymBillingPeriod)}€`;

		itemPriceLabel.textContent = `/${VgHelpers.getBillingPeriodLabel(this.gymBillingPeriod)}`;
		column.append(clone);
	}

	renderDayPassCTA(subscription) {
		const dayPassContainer = document.querySelector(".vg-compare-table__quotes-special");
		const template = document.querySelector("#quotes-special-element");

		const clone = template.content.cloneNode(true);

		const product = productsCollection?.find((product) => {
			return product.global_id.includes(subscription.product.globalId);
		});

		const subtitle = clone.querySelector(".quotes-special__subtitle");
		let subtitleText = subtitle.innerHTML;
		subtitleText = subtitleText.replace("[PRODUCT_LABEL]", subscription.product.webname);
		subtitle.innerHTML = subtitleText;

		if (product?.daypass_title) {
			const title = clone.querySelector(".quotes-special__title");
			title.innerHTML = product.daypass_title;
		}

		if (product?.daypass_subtitle) {
			subtitle.innerHTML = product.daypass_subtitle;
		}

		const link = clone.querySelector("a");
		link.setAttribute("data-label", subscription.product.webname);
		link.setAttribute("data-testid", "subscription-" + subscription.product.globalId);
		// NEW JOINING SWITCH: day passes stay in the current joining; with the new join enabled they skip to the personal data step.
		link.href = `/${this.country}-${this.lang}/joining-2/?gym=${this.center}&sub=${subscription.product.globalId}${this.newJoining ? '&skip_quote=1' : ''}`;
		const linkText = link.innerHTML;
		link.innerHTML = linkText.replace("[PRODUCT_LABEL]", subscription.product.webname);

		const price = clone.querySelector(".quotes-special__price");
		let priceText = price.innerHTML;

		if (product) {
			priceText = product.description_gym_landing || '';
		}

		priceText = priceText.replace("[PRODUCT_PRICE]", VgHelpers.priceFormat(subscription.periodPrice));
		price.innerHTML = priceText;

		dayPassContainer.appendChild(clone);
		dayPassContainer.classList.remove("is-loading");
	}

	updatePromotionBanner(subscription) {
		const promotionBanner = document.querySelector(".vg-compare-table__quotes-promotion");
		const promotionText   = promotionBanner.querySelector("[data-slot]");

		const isCreationPromoted = subscription?.creationPrice != subscription?.creationNormalPrice ? true : false;

		if (isCreationPromoted) {
			promotionBanner.classList.remove("disabled");
			promotionText.innerHTML = subscription.creationPriceText;

		} else {
			promotionBanner.classList.add("disabled");
			if (! this.tabletView) {
				document.querySelector(".vg-compare-table__quotes").remove();
			}
		}
	}

	addEventTooltipOnTable() {
		this._onTooltipHover = (event) => this.handleTooltipHover(event);
		this._onTooltipClick = (event) => this.handleTooltipClick(event);
		document.addEventListener('vg-tooltip-hover', this._onTooltipHover);
		document.addEventListener('vg-tooltip-click', this._onTooltipClick);
	}

	handleTooltipHover(event) {
		if (event.detail.content === undefined) {
			return;
		}
		event.detail.content.classList.toggle('hidden-tooltip', window.innerWidth < 801);
	}

	handleTooltipClick(event) {
		if (event.detail.content === undefined) {
			return;
		}
		// Only show modal on touch devices (mobile and tablet), not on desktop.
		const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
		if (!isTouch) {
			return;
		}

		// Prevent duplicate modals: if a modal is already open, don't create another one.
		const existingModal = document.querySelector('dialog[open]');
		if (existingModal) {
			return;
		}

		new VgModal({
			title: '',
			description: event.detail.content.innerHTML,
			data: [],
			type: 'tooltip-click',
			template: 'default',
		});
	}
}
